import $ from 'jquery';
import Resource, { ResourceApi } from '../../resource/Resource';
import { USER_RESOURCE } from '../resourceNames';

import {
  UPDATE_USER,
  UPDATE_USER_FULLNAME,
  UPDATE_USERS,
  UPDATE_USER_PREFERRED_LANGUAGE_SUCCESS,
} from './actions';
import { currentUserIdSelector } from '../Auth/selectors';
import { makeMetricsLogEvent } from '../Metrics/manualEventDispatchers';
import { OL_LANGUAGE_KEY } from '../../web/i18n/constants';
import { i18next } from '../../web/i18n';

export function updateUser(user) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_USER,
      user,
    });
  };
}

export function updateUserFullName(userId, fullName) {
  return (dispatch) => {
    if (!fullName.trim()) {
      // match the jQuery deferred response from Resource.update()
      // eslint-disable-next-line new-cap
      return $.Deferred().reject(
        Error("Name can't be blank. Please enter your name.")
      );
    }

    return Resource.update('user', userId, 'setFullName', {
      fullName,
    }).then((result) => {
      dispatch(
        makeMetricsLogEvent('ProfileChanged', {
          itemChanged: 'name',
        })
      );
      return dispatch({
        type: UPDATE_USER_FULLNAME,
        userId,
        fullName: result.fullName,
      });
    });
  };
}

/**
 * @param profileNames Array of strings (profile names)
 */
export function retrieveUserByProfileNames(profileNames) {
  return (dispatch) => {
    Resource.lookup(USER_RESOURCE, 'resources', {
      initArgsList: profileNames,
      argName: 'profileName',
    }).then((users) => {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      dispatch(setUsers(users));
    });
  };
}

export function retrieveUsersByIds({ userIds }) {
  return (dispatch) => {
    return Resource.lookup(USER_RESOURCE, 'resources', {
      initArgsList: userIds,
    }).then((users) => {
      dispatch({
        type: UPDATE_USERS,
        users,
      });
    });
  };
}

export function setUsers(users) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_USERS,
      users,
    });
  };
}

export function fetchCurrentUser() {
  return (dispatch, getState) => {
    const userId = currentUserIdSelector(getState());
    return ResourceApi.lookup(USER_RESOURCE, 'resources', {
      initArgsList: [userId],
    }).then((users) => {
      dispatch({
        type: UPDATE_USERS,
        users,
      });
    });
  };
}

export const updateUserPreferredLanguage = (user, language) => (dispatch) => {
  i18next.changeLanguage(language);
  window.localStorage.setItem(OL_LANGUAGE_KEY, language);

  if (user) {
    ResourceApi.update('user', user.get('id'), 'setPreferredLanguage', {
      language,
    }).then(() => {
      dispatch({
        type: UPDATE_USER_PREFERRED_LANGUAGE_SUCCESS,
        userId: user.get('id'),
        language,
      });
    });
  }
};
